/**
 * Angular imports.
 */
import { Component, Input, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';
import { ImageGroupService } from '../../../dataservices/master-service/image-group.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Web Events Card Component
 */
@Component({
  selector: 'app-web-events-card',
  templateUrl: './web-events-card.component.html',
  styleUrls: ['./web-events-card.component.scss']
})
export class WebEventsCardComponent implements OnDestroy {
  @Input() callingfrom;
  @Input() eventListing;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public markStatus: any;
  public showGreenGoing = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public eventShareObj: any;
  public displayObj = {
    isShow: false,
    display_section: '',
    data: [],
    errObj: []
  };
  public mediaModal = false;
  public openMediaIndex = 0;
  public mediaObj = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public eventIdCertificare: any;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();


  /**
   * Acttion information modal state.
   */
  public isActionModalShown = false;

  /**
   * Action information when clicked on mark going.
   */
  public actionData = {};

  /**
   * Necessary instances.
   */
  constructor(
    private masterService: MasterserviceService,
    public multiLangService: MultiLangService,
    public fcs: FunCollectionService,
    public postSer: PostApiService,
    private jwtSer: JwtDecodeService,
    public mls: NewLanguageService,
    public igs: ImageGroupService
  ) { }

  /**
   * navigate To Detail
   */
  navigateToDetail(id): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return false;
    }
    this.fcs.navigateToEventDetail(id);
  }

  /**
   * product Share
   */
  productShare(): void {
    this.eventShareObj = [{ share_url: this.eventListing.share_url, share_contentt: this.eventListing.share_content, product_type: 7, product_type_id: this.eventListing.event_id }];
    this.fcs.productShare(this.eventShareObj);
  }

  /**
   * mark going
   */
  markGoing(id): void {
    this.subscriptions.add(this.postSer.postEventGoing(id).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(data => {
        this.markStatus = data['status'];
        if (data['action'].type === 'alert') {
          this.isActionModalShown = true;
          this.actionData = data['action'];
          return;
        }
        if (this.markStatus == 1) {
          this.eventListing.total_registered = this.eventListing.total_registered + 1;
          this.showGreenGoing = true;
          this.eventShareModal();
        } else if (data['status'] == 0) {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * event Share Modal
   */
  eventShareModal(): void {

    this.eventShareObj = [{ share_url: this.eventListing.share_url, share_contentt: this.eventListing.share_content, product_type: 7, product_type_id: this.eventListing.event_id }];
    this.displayObj.isShow = true;
    this.displayObj.display_section = 'eventShareModal';
    this.displayObj.data = this.eventShareObj;
    this.masterService.showWebModal.next(this.displayObj);
  }

  /**
   * show certificate List
   */
  showcertificateList(id): void {
    this.eventIdCertificare = [{ eventId: id }];
    this.displayObj.isShow = true;
    this.displayObj.display_section = 'showEventCertificateList';
    this.displayObj.data = this.eventIdCertificare;
    this.masterService.showWebModal.next(this.displayObj);
  }

  /**
   * Reset information message modal.
   */
  resetActionModal(): void {
    this.isActionModalShown = false;
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

}
